import { accessRightSubMenu } from './accessRight';

// จำนวนช่องผู้อนุมัติต่อ category ใน approver_settings (approver_1..approver_10) — ต้องตรงกับ
// APPROVER_SLOT_COUNT ฝั่ง backend (backend/constants/approverSlots.constant.js)
export const APPROVER_SLOT_COUNT = 10;

// ค่าทุกช่องของ config หนึ่งตัว (รวมช่องว่าง) เรียงตามลำดับ 1..10 — ใช้แทนการเขียน
// [cfg.approver_1, cfg.approver_2, cfg.approver_3] เองทุกจุด
export const getApproverSlots = (cfg) =>
  Array.from({ length: APPROVER_SLOT_COUNT }, (_v, i) => cfg?.[`approver_${i + 1}`]);

// ผู้อนุมัติรายการเบิกเงิน (/finance/expense-approvers) — field บนสุดของ info (expense_approver_1..10)
// ไม่ได้อยู่ใน approver_settings (ดู EXPENSE_APPROVER_KEYS ฝั่ง backend) ONE_STEP = ใครก็ได้ครบ 10 ช่อง,
// THREE_STEP ใช้แค่ช่อง 1-3 ตามลำดับขั้น
export const getExpenseApproverSlots = (info) =>
  Array.from({ length: APPROVER_SLOT_COUNT }, (_v, i) => info?.[`expense_approver_${i + 1}`]);

// me (Employee._id) เป็นผู้อนุมัติรายการเบิกช่องไหนก็ได้ใน 10 ช่อง — ใช้กับโหมด ONE_STEP
export const isAnyExpenseApprover = (info, employeeId) => {
  if (!employeeId) return false;
  const myId = employeeId.toString();
  return getExpenseApproverSlots(info).some((v) => (v?._id || v)?.toString() === myId);
};

// เช็คว่า me มีสิทธิ์เห็นปุ่มอนุมัติ/ปฏิเสธของ category นี้ไหม (ตั้งค่าที่ /management/approvers,
// ApproverSettings.js — categories ที่ supportsMenuAccessMode: true เท่านั้น เช่น ot_approver,
// leave_approver, field_allowance_approver)
// - ยังไม่เคยตั้งค่าเลย (ไม่มี entry ใน approver_settings) = ทุกคนเห็นปุ่ม (คงพฤติกรรมเดิมไว้จนกว่า
//   admin จะมาตั้งค่าเอง กันไม่ให้ทุกคนเห็นปุ่มหายไปทันทีตอน deploy)
// - assign_mode 'SPECIFIC' (ค่าเริ่มต้น) = ต้องเป็น approver_1..approver_10 คนใดคนหนึ่งเท่านั้น
// - assign_mode 'MENU_ACCESS' = ไม่ต้องเลือกคนเลย ใครก็ตามที่ role มีสิทธิ์เห็นเมนู menuHref
//   (system_role.allowed_menus ผ่าน accessRightSubMenu) ถือว่ามีสิทธิ์
export function canApproveByCategory(me, info, categoryKey, menuHref) {
  const cfg = (info?.approver_settings || []).find((c) => c.key === categoryKey);
  if (!cfg) return true;

  if (cfg.assign_mode === 'MENU_ACCESS') {
    return accessRightSubMenu(me, 'HUMEN', menuHref);
  }

  const myId = me?.userData?._id?.toString();
  if (!myId) return false;
  const ids = getApproverSlots(cfg)
    .map((v) => (v?._id || v)?.toString())
    .filter(Boolean);
  return ids.includes(myId);
}

export default canApproveByCategory;
